// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b.b--menu[data-v-3d7070da]{justify-content:flex-start;padding-left:1rem;padding-right:1rem;--text-opacity:1;color:#171717;color:rgba(23,23,23,var(--text-opacity));box-shadow:none;height:2.5rem}.b.b--menu[data-v-3d7070da],.b.b--menu[data-v-3d7070da]:after{border-radius:0}@media (min-width:960px){.b.b--menu[data-v-3d7070da]{padding-left:1.25rem;padding-right:1.25rem;height:3rem}}", ""]);
// Exports
module.exports = exports;
